<template>
  <!-- Old bit.dev component -->
  <div
    @click="functionInformation"
    :class="statusClass"
    class="c-base-transaction-wrapper"
  >
    <div
      v-if="title"
      class="c-base-transaction-wrapper__title"
      v-html="title"
    ></div>

    <div class="columns is-vcentered is-gapless is-mobile">
      <div class="column">
        <div class="c-base-transaction-wrapper__name">
          <!-- Use this slot to set icon of transaction -->
          <slot name="icon-transaction">
            <span class="icon"></span>
          </slot>
          <div>
            <div>
              <span class="c-base-transaction-wrapper__box-texts--mobile">
                {{ nameDecreased }}
              </span>
              <span class="c-base-transaction-wrapper__box-texts--desktop">
                {{ name }}
              </span>
            </div>
            <span v-html="description"></span>
            <WalletTransactionProgressBar
              v-if="this.status === 'pending'"
              :valuePercent="barPercent"
            />
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="c-base-transaction-wrapper__price">
          <div class="c-base-transaction-wrapper__values">
            <span
              v-if="amountTotal > 0"
              class="c-base-transaction-wrapper__discount"
            >
              - {{ amountTotal | currency }}
            </span>
            <span class="c-base-transaction-wrapper__money">{{ price }}</span>
          </div>
          <button
            @click="functionInformation"
            class="c-base-transaction-wrapper__information"
            type="button"
          >
            <!-- Use this slot to set icon of transaction information -->
            <slot name="icon-information">
              <span class="icon"></span>
            </slot>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import WalletTransactionProgressBar from '@/components/Wallet/WalletTransactionProgressBar.vue'

export default {
  props: {
    // Function trigged on click button information
    functionInformation: {
      type: Function,
      default() {
        console.warn('Not information')
      },
    },
    // Title of transaction
    title: {
      type: String,
    },
    // Status of transaction Ex: Pending, Cancelled...
    status: {
      type: String,
    },
    // Name of transaction
    name: {
      type: String,
      required: true,
    },
    // date description
    description: {
      type: String,
      required: true,
    },
    // Date of transaction
    date: {
      type: Date,
      required: true,
    },
    // Price of transation
    price: {
      type: String,
      required: true,
    },
    // Amount Total
    amountTotal: {
      type: Number,
    },
    //Percent of Cashback Status
    barPercent: {
      type: String,
    },
  },
  components: {
    WalletTransactionProgressBar,
  },
  computed: {
    // Convert Date for humans
    dateForHumans() {
      return format(this.date, '[Em] DD/MM/YYYY [às] HH:mm')
    },
    //Decrease qtd of characters and set ellipsis into the end.
    nameDecreased() {
      return this.decreaseQtdCharacters(this.name, 58)
    },
    // Filtered e conversion status for humans
    statusForHumans() {
      if (this.status === 'cancelled') return 'Cancelada'
      if (this.status === 'pending') return 'Em Análise'
      return ''
    },
    statusClass() {
      if (this.status === 'negative')
        return 'c-base-transaction-wrapper--negative'
      else if (this.status === 'cancelled')
        return 'c-base-transaction-wrapper--cancelled'
      else if (this.status === 'pending')
        return 'c-base-transaction-wrapper--pending'
      else return ''
    },
  },
  methods: {
    decreaseQtdCharacters(str, maxLength) {
      const ellipsis = '...'
      if (str.length > maxLength) return str.substring(0, maxLength) + ellipsis
      else return str
    },
  },
}
</script>

<style lang="scss">
.c-base-transaction-wrapper {
  padding: 10px 12px 12px;

  &:hover {
    cursor: pointer;
    background-color: rgba($gray-6, 0.05);
  }

  &__title {
    margin-bottom: 12px;
    font-size: 1em;
    font-weight: bold;
    color: $support;
  }

  &__name {
    display: flex;
    align-items: center;
    font-size: 1em;
    .icon {
      color: $support;
    }
    small {
      margin-top: -2px;
      font-size: 12px;

      @media (min-width: $tablet) {
        font-size: 0.875em;
      }
    }
  }

  &__box-texts {
    &--desktop {
      display: none;
    }

    @media (min-width: 998px) {
      &--desktop {
        display: inline;
      }

      &--mobile {
        display: none;
      }
    }
  }

  &__price {
    display: block;
    text-align: right;
    @media (min-width: $tablet) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  &__values {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (min-width: $tablet) {
      display: inline-flex;
      margin-right: 18px;
    }
  }

  &__money {
    display: block;
    font-size: 1em;
    font-weight: bold;
    color: $support;
  }

  &__discount {
    font-size: 0.8em;
    text-decoration: line-through;
  }

  &__information {
    display: inline-flex;
    align-items: center;
    padding: 0;
    height: 26px;
    color: $gray-5;
    outline: none;
    cursor: pointer;
    line-height: 1;
    border: 0;
    background-color: transparent;
    &:hover,
    &:focus {
      color: $gray-6;
    }
    @media (min-width: $tablet) {
      padding: 0 7px;
      font-size: 14px;
    }
    .icon {
      width: 18px;
      height: 18px;
      color: $gray-4;
    }
  }

  &__label {
    display: none;
    line-height: 1;
    @media (min-width: $tablet) {
      display: inline;
    }
  }

  &--negative {
    .c-base-transaction-wrapper__money,
    .c-base-transaction-wrapper__name .icon {
      color: $error;
    }
  }
  &--cancelled {
    .c-base-transaction-wrapper__money,
    .c-base-transaction-wrapper__name .icon {
      color: $gray-5;
      text-decoration: line-through;
    }
    .c-base-transaction-wrapper__name .icon {
      color: $error;
    }
  }
  &--pending {
    .c-base-transaction-wrapper__money,
    .c-base-transaction-wrapper__name .icon {
      color: $gray-5;
    }
  }

  @media (min-width: $tablet) {
    .icon {
      margin-right: 6px;
    }
  }
}
</style>
